import type { ReactNode } from 'react';

export type RubySegment = string | { base: string; kana: string };

/**
 * ガイドの文中の `{感圧板|かんあつばん}` を、ふりがな付きの区間として切り出す。
 * 波かっこの対応が崩れている部分は、そのまま文字として残す。
 */
export function parseRuby(text: string): RubySegment[] {
  const segments: RubySegment[] = [];
  const pattern = /\{([^{}|]+)\|([^{}|]+)\}/g;
  let cursor = 0;
  for (let match = pattern.exec(text); match; match = pattern.exec(text)) {
    if (match.index > cursor) segments.push(text.slice(cursor, match.index));
    segments.push({ base: match[1], kana: match[2] });
    cursor = match.index + match[0].length;
  }
  if (cursor < text.length) segments.push(text.slice(cursor));
  return segments;
}

/** ふりがな記法を含む文字列を、<ruby>入りのReactノードにする。 */
export function RubyText({ text }: { text: string }): ReactNode {
  const segments = parseRuby(text);
  if (segments.every((segment) => typeof segment === 'string')) return text;
  return segments.map((segment, index) =>
    typeof segment === 'string'
      ? segment
      : <ruby key={index}>{segment.base}<rt>{segment.kana}</rt></ruby>,
  );
}
